import { QueryClient, focusManager } from '@tanstack/vue-query';
import { isRecoverableError } from '@stoxly/api-client';
import { supabase } from '@/lib/supabase';
import { updateAccessToken } from '@/lib/stoxly';

focusManager.setEventListener((setFocused) => {
  const handleVisibilityChange = async () => {
    if (document.visibilityState === 'visible') {
      try {
        const { data } = await supabase.auth.refreshSession();
        if (data.session?.access_token) {
          updateAccessToken(data.session.access_token);
        }
      } catch {
        // If refresh fails, let the 401 handler deal with it
      }
      setFocused(true);
    } else {
      setFocused(false);
    }
  };

  window.addEventListener('visibilitychange', handleVisibilityChange);
  return () => window.removeEventListener('visibilitychange', handleVisibilityChange);
});

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000,
      gcTime: 5 * 60 * 1000,
      retry: (failureCount, error) => {
        if (!isRecoverableError(error)) return false;
        return failureCount < 3;
      },
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
      refetchOnWindowFocus: true,
    },
    mutations: {
      retry: (failureCount, error) => {
        if (!isRecoverableError(error)) return false;
        return failureCount < 1;
      },
    },
  },
});
